<div class="relative container mx-auto mt-12 space-y-8">
  <div class="flex flex-col gap-2 rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10">
    <h1 class="pb-4 text-3xl text-zinc-900 dark:text-zinc-200">
      {{ pageHeader }}
    </h1>
    <p>Please answer each question to the best of your ability</p>
    <p class="pb-4">
      {{ instructions }}
    </p>
  </div>

  <div class="flex flex-col gap-2 rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10">
    <h2 class="pb-4 text-2xl text-zinc-900 dark:text-zinc-200">
      {{ header }}
    </h2>
    <div role="alert" *ngIf="error">
      {{ error }}
      <button type="button" data-dismiss="alert" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form [formGroup]="impactForm" (ngSubmit)="onForward()" class="flex flex-col gap-4">
      <p class="impact" [innerHTML]="qq()"></p>
      <textarea type="text"
        class="w-full self-start rounded-lg border px-1 py-1 shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
        formControlName="answer" 
        (blur)="onFieldBlur()"
        rows="6"></textarea>
      <!-- multi-question support -->
      <!-- <div *ngFor="let question of questions; let i = index">
        <p class="impact" [innerHTML]="question.Text"></p>
        <textarea
          type="text"
          class="w-full self-start rounded-lg border px-1 py-1 shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          [formControlName]="'answer_' + i"
          rows="6"
        ></textarea>
      </div> -->
      <div class="flex justify-center">
        <button
          [class]="impactForm.valid 
            ? 'cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-white outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none'
            : 'cursor-not-allowed justify-center rounded-lg bg-zinc-400 px-3 py-2 font-semibold text-zinc-100 outline-offset-2'"
          [disabled]="!impactForm.valid" type="submit">
          Save & Continue
        </button>
      </div>
    </form>
  </div>
  <div *ngIf="isLoading" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform">
    <app-loading-spinner></app-loading-spinner>
  </div>
</div>